import axios from "axios";
import store from '@/store'
import {messages} from '@moeinmdn/miw-alpha-components/src/package/Translate/Original'
import {builderBaseUrl} from "@/main";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {
    siteRoutesTemplateChild,
    dashboardRoutesTemplateChild,
    siteRoutes
} from '@moeinmdn/miw-router/src/package/routes/SiteRoutes'
import {addRoute, removeRoute} from "@/router";

let originalLanguageMessages = JSON.parse(JSON.stringify(messages['originalLanguage']))


export const flatRouter = (routes) => {
    return Array.isArray(routes)
        ? routes.reduce((a, item) => {
            a.push(item);
            if (item.children) {
                a = a.concat(flatRouter(item.children));
            }
            return a;
        }, []) : [];
}


export const generateRandomString = () => {
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
    );
}

export const traverseAndFlatten = (currentNode, target, flattenedKey) => {
    for (var key in currentNode) {
        if (currentNode.hasOwnProperty(key)) {
            var newKey;
            if (flattenedKey === undefined) {
                newKey = key;
            } else {
                newKey = flattenedKey + '.' + key;
            }

            var value = currentNode[key];
            if (typeof value === "object") {
                traverseAndFlatten(value, target, newKey);
            } else {
                target[newKey] = value;
            }
        }
    }
}

export const flatten = (obj) => {
    var flattenedObject = {};
    traverseAndFlatten(obj, flattenedObject);
    return flattenedObject;
}

export const isJson = (item) => {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
}

export const createNestedObject = (base, names, value) => {
    var item = arguments.length === 3 ? names.pop() : false;

    for (var i = 0; i < names.length; i++) {
        base = base[names[i]] = base[names[i]] || {};
    }

    if (item) base = base[item] = value;

    return base;
};

export const setPropValue = (value, typeOfValue) => {
    if (typeOfValue == 'Object' && value != 'null' && value != '' && value != null) {
        let arrayToString = typeof value == 'object' ? value : value.split(',')
        return arrayToString.length === 1 ? [arrayToString[0]] : arrayToString
    }
    if (value == 'null' || (typeOfValue == 'Object' && value == '')) {
        return null
    }
    if (typeOfValue == 'Boolean') {
        return (value === 'true' || value === true)
    }
    if (typeOfValue == 'String') {
        return value
    }
    if (!isNaN(parseInt(value))) {
        return Number(value);
    }
    return value
}

export const resolveSelectPropValue = (currentValue, rawProp) => {
    if (!rawProp || !Array.isArray(rawProp.options) || rawProp.options.length === 0) {
        return currentValue
    }
    if (rawProp.options.indexOf(currentValue) !== -1) {
        return currentValue
    }
    const fallback = rawProp.default
    if (fallback !== undefined && rawProp.options.indexOf(fallback) !== -1) {
        return fallback
    }
    return rawProp.options[0]
}

export const setComponentPropValues = (componentProps, component) => {
    let value = {}
    let propOptions = component.rawProps
    Object.entries(componentProps).forEach((item, index) => {
        const propKey = item[0]
        const propValue = componentProps[propKey];
        const rawProp = propOptions[propKey] || {}
        let propType = rawProp.type
        propType = propType != undefined ? propType.name : ''
        if (propValue == undefined) {
            value[propKey] = setPropValue(item[1], propType)
        } else {
            value[propKey] = setPropValue(propValue, propType)
        }
        value[propKey] = resolveSelectPropValue(value[propKey], rawProp)
    })
    return value
}


export const findCustomRoutes = () => {
    let routes = []

    let site = store.getters["Site/getSite"]

    let getSiteSelectedLanguage = store.getters["Site/getSiteSelectedLanguage"]

    let currentSiteRoutes = site[getSiteSelectedLanguage]['pages']


    flatRouter(siteRoutes).forEach(item => {
        routes.push(item.name)
    })


    let result = []


    Object.entries(currentSiteRoutes).forEach(item => {
        let key = item[0]
        let value = item[1]

        const condition = routes.indexOf(key);
        if (condition == -1) {
            result.push({name: key, path: value.routeConfig.routePath})
        }
    })

    return result


}

export const changeIdOfComponentJson = (componentJson) => {
    componentJson.id = generateRandomString()
    Object.entries(componentJson.slots).forEach(slotName => {
        Object.entries(slotName[1].components).forEach(slotComponent => {
            changeIdOfComponentJson(slotComponent[1])
        })
    })
}
export default {
    namespaced: true,
    state: {
        site: {
            fa: {
                pages: {
                    Home: {
                        components: [],
                        routeConfig: [],
                    },
                },
                translations: originalLanguageMessages,
                header: '',
            }
        },
        selectedPage: 'Home',
        languageInfo: {},
        selectedLanguage: 'fa',
        defaultLanguage: 'fa',
        globalStyle: '',
        // با هر جایگزینی کامل سایت بالا می‌رود تا درخت پیش‌نمایش از نو mount شود
        previewEpoch: 0,
        selectedComponent: {
            id: '',
            slot: 'default'
        },
        componentModalStatus: false,
    },
    mutations: {
        setSite(state, content) {
            state['site'] = content
            state.previewEpoch += 1
        },
        bumpPreviewEpoch(state) {
            state.previewEpoch += 1
        },
        addComponent(state, {component, componentPath}) {
            component['page'] = state.selectedPage;
            if (state.selectedComponent.id === '') {
                state.site[state.selectedLanguage]['pages'][state.selectedPage].components.push(component)
            } else {
                componentPath = componentPath.split('.')
                componentPath.pop()

                const lastPath = componentPath.pop();


                let PageComponent = state.site[state.selectedLanguage]['pages'][state.selectedPage]

                componentPath.forEach(item => {
                    PageComponent = PageComponent[item]
                })

                if (PageComponent[lastPath]['slots'][state.selectedComponent.slot]['components'] == undefined) {
                    PageComponent[lastPath]['slots'][state.selectedComponent.slot] = {
                        components: [],
                        text: "",
                    }
                }


                PageComponent[lastPath]['slots'][state.selectedComponent.slot]['components'].push(component)
            }
        },
        changeSitePage(state, sitePage) {
            state.selectedPage = sitePage
        },
        changeSiteLanguage(state, language) {
            state.selectedLanguage = language
        },
        addPage(state, sitePage) {
            let originalRoute = flatRouter(siteRoutes).map(item => item.name)

            let isCustomRoute = originalRoute.indexOf(state.selectedPage) === -1
            if (isCustomRoute) {
                state.site[state.selectedLanguage]['pages'][sitePage] = {
                    components: [],
                    routeConfig: {panels: ['*'], routePath: `/${generateRandomString()}`}
                }
            } else {
                state.site[state.selectedLanguage]['pages'][sitePage] = {components: [], routeConfig: {panels: ['*']}}
            }

        },
        addLanguage(state, language) {
            let messagesCopy = JSON.parse(JSON.stringify(messages['originalLanguage']))
            state.site[language] = {pages: {Home: {components: []}}, translations: messagesCopy, header: ''}
        },
        removeComponent(state, componentPath) {
            componentPath = componentPath.split('.')
            componentPath.pop()

            const lastPath = componentPath.pop();


            let component = state.site[state.selectedLanguage]['pages'][state.selectedPage]

            componentPath.forEach(item => {
                component = component[item]
            })
            component.splice(lastPath, 1)
        },
        replaceComponentValue(state, {componentPath, newLayer}) {
            // مسیر را جدا کن
            componentPath = componentPath.split('.');
            let lastPath = componentPath.pop(); // اندیس یا کلید آخر
            lastPath = componentPath.pop(); // اندیس یا کلید آخر

            // دسترسی به آرایه والد
            let component = state.site[state.selectedLanguage]['pages'][state.selectedPage];
            componentPath.forEach(item => {
                component = component[item];
            });

            // جایگزینی مقدار جدید
            component[lastPath] = newLayer
        },
        clearComponentText(state, {component, slot}) {
            component['slots'][slot]['text'] = ''
        },
        moveComponentPosition(state, {componentPath, mode}) {
            componentPath = componentPath.split('.')
            componentPath.pop()

            const indexOfComponentInPage = parseInt(componentPath.pop());


            let component = state.site[state.selectedLanguage]['pages'][state.selectedPage]

            componentPath.forEach(item => {
                component = component[item]
            })
            if (mode === 'up') {
                if (indexOfComponentInPage > 0) {
                    component.splice(indexOfComponentInPage - 1, 1, component.splice(indexOfComponentInPage, 1, component[indexOfComponentInPage - 1])[0]);
                }
            }
            if (mode === 'down') {
                if (indexOfComponentInPage < component.length - 1) {
                    component.splice(indexOfComponentInPage + 1, 1, component.splice(indexOfComponentInPage, 1, component[indexOfComponentInPage + 1])[0]);
                }

            }
        },
        setDefaultLanguage(state, language) {
            state.defaultLanguage = language
        },
        setGlobalStyle(state, globalStyle) {
            state.globalStyle = globalStyle
        },
        setSelectedComponent(state, {id, slot}) {
            state.selectedComponent.id = id
            state.selectedComponent.slot = slot
        },
        setTranslationItem(state, {value, translationItemPath}) {
            let translationObject = state.site[state.selectedLanguage].translations
            translationItemPath = translationItemPath.split('.')
            const translationItemPathLastLastItem = translationItemPath.slice(-1) // store last one before we remove it
            translationItemPath.pop()

            translationItemPath.forEach(key => {
                translationObject = translationObject[key]
            })

            translationObject[translationItemPathLastLastItem] = value
        },
        setSiteHeader(state, siteHeader) {
            state.site[state.selectedLanguage]['header'] = siteHeader
        },
        setComponentModalStatus(state, value) {
            state.componentModalStatus = typeof value === 'boolean' ? value : !state.componentModalStatus
        },
    },
    actions: {
        checkTranslations({commit, dispatch}, content) {
            let originalTranslations = flatten(originalLanguageMessages)
            // loop on all translation of site language
            Object.keys(content).forEach(site => {

                let translations = content[site]['translations']
                let siteTranslation = flatten(translations)

                // loop on originalTranslations item
                Object.entries(originalTranslations).forEach((originalTranslate) => {
                    const key = originalTranslate[0]
                    const value = originalTranslate[1]
                    // compare site translation item with original
                    if (Object.keys(siteTranslation).indexOf(key) === -1) {
                        // if new item not exist on translation we set it with default value of original translation
                        createNestedObject(translations, key.split('.'), value)
                    }

                })


            })
        },
        checkRouteConfig({commit, dispatch}, content) {
            let siteRoutes = flatRouter(siteRoutesTemplateChild)
            let dashboardRoutes = flatRouter(dashboardRoutesTemplateChild)
            let originalRoutes = {
                ...siteRoutes,
                ...dashboardRoutes
            }

            // find routes without any route config
            for (let [key, site] of Object.entries(content)) {
                const pages = site['pages']
                for (let [key, page] of Object.entries(pages)) {
                    if (Object.keys(page).indexOf('routeConfig') === -1) { // set config route
                        page['routeConfig'] = {panels: ['*']}
                    }
                }
            }

        },
        addCustomRoutesToMainRouter({commit, dispatch}) {
            let customRoutesList = findCustomRoutes();

            customRoutesList.forEach(item => {

                addRoute(item)
            })
        },
        removePreviewsSiteCustomRoutesFromMainRouter({commit, dispatch}) {
            let customRoutesList = findCustomRoutes();

            customRoutesList.forEach(item => {

                removeRoute(item.name)
            })
        },
        async checkLanguageInfo({state, commit, dispatch}, content) {
            // set languageInfo
            let languages = []
            await store.dispatch('Language/getLanguages').then(res => {
                languages = res.data.data
            })
            let siteLanguages = Object.keys(content)

            let result = []

            languages.forEach(item => {

                if (siteLanguages.indexOf(item.slug) > -1) {

                    result.push(item)

                }


            })

            state.languageInfo = result

        },
        async setGlobalRoutes({state, commit, dispatch}, content) {

            let customRoutes = findCustomRoutes();

            let routes = [
                ...siteRoutesTemplateChild, ...dashboardRoutesTemplateChild, ...customRoutes
            ]
            Object.entries(routes).forEach(item => {
                delete item[1]['beforeEnter']
                delete item[1]['component']
                delete item[1]['components']
            })
            state['main_routes'] = routes
        },
        setSite({state, commit, dispatch}, content) {
            // remove custom routes from previews site
            dispatch('removePreviewsSiteCustomRoutesFromMainRouter')

            // check translations, if we have new item in origin, add it to site language translations
            dispatch('checkTranslations', content)
            dispatch('checkRouteConfig', content)
            dispatch('checkLanguageInfo', content)
            commit('setSite', content)
            dispatch('addCustomRoutesToMainRouter')
        },
        async addComponent({state, commit, dispatch}, component) {
            const componentPath = await dispatch('findComponentPath', state.selectedComponent.id);
            commit('addComponent', {component, componentPath})
        },
        async buildSite({state, commit, dispatch}, form) {
            await dispatch('storeSite')
            const user_id = store.getters['User/getUserId']
            const project_id = store.getters['ProjectAlpha/getProject'].id
            return axios.post(`${builderBaseUrl}/site/project/${project_id}/user/${user_id}`, form)
        },
        storeSite({state, commit}) {
            const site = JSON.stringify({
                site: state.site,
                global_style: state.globalStyle,
                default_language: state.defaultLanguage,
                languageInfo: state.languageInfo,
                main_routes: state.main_routes,
            });
            const user_id = store.getters['User/getUserId']
            const project_id = store.getters['ProjectAlpha/getProject'].id
            const form = {site_json: site}

            return axios.post(`${builderBaseUrl}/project-history/${project_id}/user/${user_id}`, form)
        },
        compileScss({state, commit}) {
            const user_id = store.getters['User/getUserId']
            const project_id = store.getters['ProjectAlpha/getProject'].id
            const form = {global_style: state.globalStyle}

            return axios.post(`${builderBaseUrl}/project/${project_id}/user/${user_id}/sass2css`, form)
        },
        changeSitePage({state, commit}, sitePage) {
            const sitePages = Object.keys(state.site[state.selectedLanguage]['pages'])

            if (sitePages.indexOf(sitePage) === -1) {
                commit('addPage', sitePage)
            }

            commit('changeSitePage', sitePage)


        },
        changeSiteLanguage({state, commit, dispatch}, language) {

            dispatch('removePreviewsSiteCustomRoutesFromMainRouter')

            const sitePages = Object.keys(state.site)
            // make language(id) to string for make sure indexOf have correct result
            if (sitePages.indexOf(language.toString()) === -1) {
                commit('addLanguage', language)
            }

            commit('changeSiteLanguage', language)

            // add current page to current language if not exists
            if (state.site[language]['pages'][state.selectedPage] === undefined) {
                commit('addPage', state.selectedPage)
            }

            // check header section on page, if not exists add it to json
            if (state.site[language]['header'] === undefined) {
                state.site[language]['header'] = ''
            }
            dispatch('addCustomRoutesToMainRouter')
        },
        findComponentPath({state}, componentId) {
            let result = null
            let pageComponents = state.site[state.selectedLanguage]['pages'][state.selectedPage]
            const id = componentId != null ? String(componentId) : ''
            Object.entries(flatten(pageComponents)).forEach(([path, raw]) => {
                if (raw === undefined || raw === 'undefined') return
                const value = raw.toString()
                if (path.endsWith('.id') && value === id) {
                    result = path
                } else if (!result && value.indexOf(id) > -1) {
                    result = path
                }
            })
            return result
        },
        async removeComponent({state, commit, dispatch}, componentId) {
            const componentPath = await dispatch('findComponentPath', componentId);
            commit('removeComponent', componentPath)
        },
        async updateComponentValue({state, commit, dispatch}, {componentId, newLayer}) {
            const componentPath = await dispatch('findComponentPath', componentId);
            commit('replaceComponentValue', {componentPath, newLayer})
        },
        async clearComponentText({state, commit, dispatch}, {id, slot}) {
            const componentPath = await dispatch('findComponentPath', id);
            const component = await dispatch('pathToComponent', {componentPath})
            commit('clearComponentText', {component, slot})
        },
        async pathToComponent({state}, {componentPath}) {
            componentPath = componentPath.split('.')
            componentPath.pop()

            const lastPath = componentPath.pop();


            let component = state.site[state.selectedLanguage]['pages'][state.selectedPage]

            componentPath.forEach(item => {
                component = component[item]
            })
            return component[lastPath]
        },
        async moveComponentPosition({state, commit, dispatch}, {componentId, mode}) {
            let componentPath = await dispatch('findComponentPath', componentId);
            commit('moveComponentPosition', {componentPath, mode})
        },
        async cutComponentJson({dispatch}, layer) {
            await dispatch('copyComponentJson', layer)
            await dispatch('removeComponent', layer.id)
            toast('برش انجام شد — برای جای‌گذاری Paste کنید', 'برش انجام شد')
        },
        setGlobalStyle({commit}, globalStyle) {
            commit('setGlobalStyle', globalStyle)
        },
        setSelectedComponent({commit}, {id, slot}) {
            commit('setSelectedComponent', {id, slot})
        },
        setTranslationItem({state, commit}, {value, translationItemPath}) {
            commit('setTranslationItem', {value, translationItemPath})

        },
        setSiteHeader({commit}, siteHeader) {
            commit('setSiteHeader', siteHeader)
        },
        setComponentModalStatus({commit}, value) {
            commit('setComponentModalStatus', value)
        },
        copyComponentJson({commit}, layer) {
            var text = JSON.stringify(layer);
            navigator.clipboard.writeText(text).then(function () {
                toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
            }, function (err) {
                console.log('Copy Error => ', err)
            });
        },
        /*
        * if you want to add component as last item of page,
        * make addToSelectedLayer equal to false and fill other values with null
        *
        *  */
        async pastComponentJson({commit, dispatch}, {currentLayer, key, addToSelectedLayer = true}) {
            let layer = await navigator.clipboard.readText();
            try {
                layer = JSON.parse(layer)
            } catch (e) {
                toast('متن کپی شده معتبر نمیباشد.', 'متن کپی شده معتبر نمیباشد.', 'danger')
                console.log('Past Error => ', e)
                return false
            }
            await dispatch('setSelectedComponent', {id: '', slot: 'default'})
            if (addToSelectedLayer) {
                await dispatch('setSelectedComponent', {id: currentLayer.id, slot: key})
            }

            let newLayer = Object.assign({}, layer);
            changeIdOfComponentJson(newLayer)
            await dispatch('addComponent', newLayer)
        },
        async getHistoryLog({state, commit, dispatch}, form) {
            const user_id = store.getters['User/getUserId']
            let req = axios.post(`${builderBaseUrl}/project-history-log/${form.history_id}/user/${user_id}`, form)
            return req
        },
    },
    getters: {
        getSite: state => state.site,
        getSiteSelectedPage: state => state.selectedPage,
        getSiteSelectedLanguage: state => state.selectedLanguage,
        getSiteTranslations: state => state.site[state.selectedLanguage].translations,
        getSiteHeader: state => state.site[state.selectedLanguage]['header'],
        getSelectedComponent: state => state.selectedComponent,
        getComponentModalStatus: state => state.componentModalStatus,
        getGlobalStyle: state => state.globalStyle,
        getPreviewEpoch: state => state.previewEpoch,
    },
}